import { render, staticRenderFns } from "./LatePenalties.vue?vue&type=template&id=48456b7d&"
import script from "./LatePenalties.vue?vue&type=script&lang=js&"
export * from "./LatePenalties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports